import { SewingPinIcon } from '@radix-ui/react-icons';
import { Button, Skeleton } from '@radix-ui/themes';
import { openInExternalUrl } from 'helpers/utils';
import type { ClubPageType } from 'types/club';
import Container from './Container';

export const ClubBasicInfo: React.FC<
  Partial<ClubPageType> & {
    loading: boolean;
  }
> = ({ phone, legal_address, fields_address, mail_address, loading }) => {
  const itemClassName = 'bg-white gap-2 p-3 rounded-xl border border-solid border-neutral-neutral-2';
  const labelClassName = 'self-stretch text-neutral-neutral-8 text-sm font-medium tracking-normal';
  const contentClassName = 'text-neutral-neutral-alpha-12 text-lg font-bold tracking-normal';
  return (
    <Container title='Informazioni base:'>
      <div id='info' className='grid w-full grid-cols-1 flex-wrap items-stretch gap-2 self-stretch'>
        <div id='address' className={itemClassName}>
          <div id='title5' className={labelClassName}>
            Indirizzo campi
          </div>
          <div id='value5' className={contentClassName}>
            <Skeleton loading={loading}>
              <div className='min-h-6 min-w-20 underline'>{fields_address}</div>
            </Skeleton>
          </div>
          <div className='pt-2'>
            <Button variant='soft' size='2'>
              <div
                onClick={() =>
                  openInExternalUrl(
                    `https://www.google.com/maps/search/?api=1&query=${
                      fields_address ? fields_address : legal_address ? legal_address : name
                    }`,
                  )
                }
              >
                <SewingPinIcon></SewingPinIcon>Apri mappa
              </div>
            </Button>
          </div>
        </div>

        <div id='phone' className={itemClassName}>
          <div id='' className={labelClassName}>
            Numero di telefono
          </div>
          <div id='value4' className={contentClassName}>
            <Skeleton loading={loading}>
              <div className='min-h-6 min-w-20 underline'>
                <a href={`tel:${phone}`}>{phone}</a>
              </div>
            </Skeleton>
          </div>
        </div>

        <div id='mail' className={itemClassName}>
          <div id='label3' className={labelClassName}>
            Indirizzo Email
          </div>
          <div id='value3' className={contentClassName}>
            <Skeleton loading={loading}>
              <div className='min-h-6 min-w-20 underline'>
                <a href={`mailto:${mail_address}`}>{mail_address}</a>
              </div>
            </Skeleton>
          </div>
        </div>
        <div id='legal' className={itemClassName}>
          <div id='label4' className={labelClassName}>
            Sede legale
          </div>
          <div id='value4' className={contentClassName}>
            <Skeleton loading={loading}>
              <div className='min-h-6 min-w-20 underline'>{legal_address}</div>
            </Skeleton>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ClubBasicInfo;
